// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDCVR0g_ygsm7X7xjQif9fltXh63ipdJ_s",
    authDomain: "aspi-64567.firebaseio.com",
    databaseURL: "https://aspi-64567.firebaseio.com",
    projectId: "aspi-64567",
    storageBucket: "aspi-64567.appspot.com",
    messagingSenderId: "998626777069"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
